import { render } from "./DescriptionComponent.vue?vue&type=template&id=4831f5e6&ts=true"
import script from "./DescriptionComponent.vue?vue&type=script&lang=ts"
export * from "./DescriptionComponent.vue?vue&type=script&lang=ts"

import "./DescriptionComponent.vue?vue&type=style&index=0&id=4831f5e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__